import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/scss/styles.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './style.css'

createApp(App).use(router).mount('#app')
